import { Directive, HostListener, Input, inject } from '@angular/core';
import { AppFacadeService } from '../../services/app-facade.service';

@Directive({
    standalone: false,
    selector: '[porAppPushState]'
})
export class PushStateDirective {
    private readonly appFacadeService = inject(AppFacadeService);

    @Input() tab!: string | undefined;
    @HostListener('click', ['$event']) onClick(event: Event) {
        event.preventDefault();
        this.appFacadeService.updateLocation(this.tab || '');
    }
}
